module.exports = __webpack_public_path__ + "static/Authentic-Traveling-Logo.png";